import { ReactElement } from 'react'
import SubmissionsLogsFilters from './SubmissionsLogsFilters'
import { useServiceSubmissionsLogs } from './useServiceSubmissionsLogs'
import { Grid } from '@mui/material'
import SubmissionsLogsTable from './SubmissionsLogsTable'

export default function SubmissionsLogs(): ReactElement {

	const {
		//STATES
		page,
		setPage,
		filters,
		setFilters,
		selectedRows,
		handleSelectRow,
		handleSelectAll,

		//MENUS
		actionsMenu,
		setActionsMenu,

		//DATA
		data,
		lookupTables,
		sections,

		//ERRORS
		error,
		errorLookupTables,
		errorSections,

		//LOADING
		isLoading,
		isLoadingSections,
		isLoadingLookupTables,

		//ACTIONS
		handleCancelSubmissions,
	} = useServiceSubmissionsLogs()

	return <>

		<SubmissionsLogsFilters
			filters={filters}
			setFilters={setFilters}
			lookupTables={lookupTables}
			isLoadingLookupTables={isLoadingLookupTables}
			errorLookupTables={errorLookupTables}
			sections={sections}
			errorSections={errorSections}
			isLoadingSections={isLoadingSections}
			selectedRows={selectedRows}
			actionsMenu={actionsMenu}
			setActionsMenu={setActionsMenu}
			handleCancelSubmissions={handleCancelSubmissions}
		/>

		<Grid item xs={12} maxHeight={'calc(100vh - 200px)'}>
			<SubmissionsLogsTable
				data={data}
				selectedRows={selectedRows}
				handleSelectRow={handleSelectRow}
				handleSelectAll={handleSelectAll}
				isLoading={isLoading}
				error={error}
				page={page}
				setPage={setPage}
			/>
		</Grid>

	</>
}

